import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EmailTemplateResponse } from '../../../types/EmailTemplate';

type UseGetAllEmailTemplateParams = {
  page?: number;
  per_page?: number;
  search?: string,
  filters?: {
    archived?: boolean;
  };
};

export type UseGetAllEmailTemplateProps = {
  params?: UseGetAllEmailTemplateParams;
  enabled?: boolean;
};

export const fetchAllEmailTemplate = async ({ params }: UseGetAllEmailTemplateProps) => {
  const response = await CustomAxios.get<EmailTemplateResponse>(`email_templates`, { params });
  const { data } = response;
  return data;
};

export function useGetAllEmailTemplate({ params, enabled = true }: UseGetAllEmailTemplateProps) {
  const queryKey: any = [queryKeys.allEmailTemplates, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllEmailTemplate({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
